import { TableColumns } from '@bp/ui-components';
import { CellContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { LicenseLock } from '../../LicenseHint/LicenseHint';

/**
 * Ohne gebuchtes Modul Deputate liefert der Server Deputate nur für die ersten fünf Lehrkräfte. Für alle weiteren
 * (`locked`) zeigen die Deputats-Spalten statt eines Werts das Schloss mit dem Buchungshinweis (in `chipColumn`) bzw. „–“.
 */
export function lockUnlicensedColumns<T extends { locked?: boolean }>(
  columns: TableColumns<T>[],
  { lockedColumns, chipColumn }: { lockedColumns: string[]; chipColumn: string },
): TableColumns<T>[] {
  return columns.map((column) => {
    if (!lockedColumns.includes(column.id)) return column;
    const original = column.cell;
    return {
      ...column,
      cell: (context: CellContext<T, unknown>): ReactNode => {
        if (context.row.original.locked) {
          return column.id === chipColumn ? <LicenseLock hint={{ kind: 'teachingLoad' }} /> : '–';
        }
        if (typeof original === 'function') return original(context);
        return original ?? String(context.getValue() ?? '');
      },
    };
  });
}

/** Lehrkräfte, für die der Server Deputatsdaten geliefert hat. */
export const teachersWithData = (loads: ReadonlyArray<{ teacherUuid: string }> | undefined): Set<string> =>
  new Set((loads ?? []).map((load) => load.teacherUuid));
